import { loadView } from '@/router'
import assets from './assets'
import locations from './locations'
export default [
  {
    path: 'configuration',
    name: 'configuration',
    component: loadView('Application/Configuration'),
    redirect: {
      name: 'configuration-locations'
    },
    children: [
      ...assets,
      ...locations,
      {
        path: 'tracking-error-log',
        name: 'configuration-tracking-error-log',
        component: loadView('Application/Configuration/TrackingLog')
      },
      {
        path: 'tracking-notification-logs',
        name: 'configuration-tracking-notification-logs',
        component: loadView('Application/Configuration/TrackingNotificationLogs')
      },
      {
        path: 'legacy-workers',
        name: 'configuration-legacy-workers',
        component: loadView('Application/Configuration/LegacyWorkers')
      },
      {
        path: 'incidents',
        name: 'configuration-incidents',
        component: loadView('Application/Configuration/Incidents')
      },
      {
        path: 'service-disruptions',
        name: 'configuration-service-disruptions',
        component: loadView('Application/Configuration/ServiceDisruptions')
      },
      {
        path: 'holidays',
        name: 'configuration-holidays',
        component: loadView('Application/Configuration/Holidays')
      },
      {
        path: 'blacklist',
        name: 'configuration-blacklist',
        component: loadView('Application/Configuration/Blacklist')
      },
      {
        hidden: true,
        path: 'playground',
        name: 'configuration-playground',
        component: loadView('Application/Configuration/Playground')
      },
      // {
      //   path: 'transit-time-rules',
      //   name: 'configuration-transit-time-rules',
      //   component: loadView('Application/Configuration/TransitTimeRules')
      // },
      {
        path: 'jobs',
        name: 'configuration-jobs',
        component: loadView('Application/Configuration/Jobs')
      }
    ]
  }
]
